import React, { useState, useEffect, useMemo } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { MdOutlineFileUpload } from "react-icons/md";
import { baseUrl } from "../../../../network/constants/constants";
import axios from "../../../../network/api";
import config, { getConfig } from "../../../../network/auth";
import { Spinner } from "react-bootstrap";
import dummyImage from './../../../dummyImages/cleanig.jpg';
import "./Banner.css";


function Banner() {
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null); 
  const [validationError, setValidationError] = useState({
    banner: "",
  });

  const config = useMemo(() => {
    return getConfig()
  },[])
  // delete image
  const deleteImage = (imageId) => {
    setLoading(true);

    axios
      .delete(baseUrl + `${imageId}/`, config)
      .then((response) => {
        setBanner(banner.filter((image) => image.id !== imageId));
        setLoading(false);
      })
      .catch((error) => {
        console.error("image Error:", error);
        setLoading(false);
      });
  };

  const fetchBanner = () => {
    setLoading(true);
    axios
      .get(baseUrl + ``, config)
      .then((response) => {
        setLoading(false);
        setBanner(response.data);
      })
      .catch((error) => {
        console.error("Gallery Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchBanner();
  }, []);

  // Post banner
  const handleBannerSubmit = (event, close) => {
    event.preventDefault();
    setValidationError({ banner: "" });

    if (!selectedFile) {
      setValidationError({ banner: "Please select an image to upload." });
      return;
    }

    const formData = new FormData();
    formData.append("gallery_images", selectedFile);
    setLoading(true);

    axios
      .post(`${baseUrl}`, formData, config)
      .then((response) => {
        setLoading(false);
        fetchBanner();
        setBanner([...banner, response.data]);
        close();
      })
      .catch((error) => {
        console.error("Error: ", error);
        setLoading(false);
      });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewImage(URL.createObjectURL(file)); 
      setValidationError({ banner: "" });
    }
  };

  return (
    <div className="main-div">
      <>
        <div style={{ padding: "10px" }}>
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
          >
            <Masonry gutter="20px">
              <div className="gallery-img-div">
                <Popup
                  className="popup-container"
                  contentStyle={{
                    borderRadius: "20px",
                    backgroundColor: "white",
                  }}
                  trigger={
                    <span className="material-icons delete-icon">
                      delete_forever
                    </span>
                  }
                  modal
                  nested
                >
                  {(close) => (
                    <div className="delete-img-div">
                      <h3 className="delete-img-heading">Are you sure?</h3>
                      <p className="delete-img-p">
                        Do you really want to delete?
                      </p>
                      <div className="delete-btn-div">
                        <button
                          onClick={() => {
                            // deleteImage(image.id);
                            close();
                          }}
                        >
                          Delete
                        </button>
                        <button onClick={close}>Cancel</button>
                      </div>
                    </div>
                  )}
                </Popup>
                <img
                  // src={`${baseUrl}${image.gallery_images}`}
                  src={dummyImage}
                  style={{
                    width: "100%",
                    display: "block",
                    cursor: "pointer",
                  }}
                  alt="images"
                />
              </div>
            </Masonry>
          </ResponsiveMasonry>
        </div>

        <Popup
          className="add-popup-container"
          contentStyle={{ borderRadius: "20px" }}
          trigger={<button className="btn-add">+ Add Banner</button>}
          modal
          nested
        >
          {(close) => (
            <div className="add-img-div">
              <form
                method="post"
                onSubmit={(e) => handleBannerSubmit(e, close)}
              >
                <h3 className="add-img-heading">Add Banner image</h3>
                <label className="add-file-upload">
                  <input
                    className="add-img-file"
                    id="file"
                    type="file"
                    onChange={handleFileChange}
                  />
                  <MdOutlineFileUpload className="upload-icon" />
                </label>
                {validationError.banner && (
                  <p className="error-text">{validationError.banner}</p>
                )}
                {previewImage && (
                  <div className="image-preview-container">
                    <h4 style={{fontSize: "16px", marginTop: "5px"}}>Image Preview:</h4>
                    <img
                      src={previewImage}
                      alt="Preview"
                      className="preview-image"
                   
                    />
                  </div>
                )}
                <div className="submit-banner-file-container">
                  <button type="submit">Upload</button>
                  <button type="button" onClick={close}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          )}
        </Popup>
      </>
    </div>
  );
}

export default Banner;
